import { useEffect, useState } from 'react';
import LeftSidePopupLayout from './modal-layout';
import XCloseIcon from '../icons/x-close';
import Style from './style.module.css'
import { useApiCall } from '../custom-hooks/api-call';
import { useFormik } from 'formik';
import * as yup from "yup";
import InnerLoader from '../ui/loader/inner-loader';
import { File, UploadCloud } from 'lucide-react';
import { Link } from 'react-router';

const CarDamageModal = ({ onSubmit = () => { }, onClose = () => { }, onError = () => { }, damageData, cars = [] }) => {
  const [imgError , setImgError] = useState([]);
  const [invoiceError, setInvoiceError] = useState(false)

  const apiCall = useApiCall();

  useEffect(() => {  
    console.log("damageData", damageData)
    if (damageData?.id) {
      let breakupCost = JSON.parse(damageData?.repair_cost_breakup)
      formik.setFieldValue("car", damageData?.car_id || "")
      formik.setFieldValue("incident_date", damageData?.incident_date || "")
      formik.setFieldValue("incidentType", damageData?.incident_type || "")
      formik.setFieldValue("location", damageData?.incident_location || "")
      formik.setFieldValue("severity", damageData?.severity || "")
      formik.setFieldValue("damageDetail", damageData?.damage_description || "")
      formik.setFieldValue("damageStatus", damageData?.damage_status || "")
      formik.setFieldValue("cost", damageData?.repair_cost || "")
      formik.setFieldValue("claimStatus", damageData?.insurance_claim_status || "")
      formik.setFieldValue("policeReport", damageData?.police_report_number || "")
      formik.setFieldValue("description", damageData?.description || "")
      formik.setFieldValue("comment", damageData?.final_comment || "")
      formik.setFieldValue("invoice", damageData?.invoice || "")
      formik.setFieldValue("incidentImg", JSON.parse(damageData?.incident_images) || "")
      formik.setFieldValue("employeeCost", breakupCost?.employee || "")
      formik.setFieldValue("employerCost", breakupCost?.employer || "")
      formik.setFieldValue("vendorCost", breakupCost?.vendor || "")
      formik.setFieldValue("insuranceCost", breakupCost?.insurance || "")
    }
  }, [damageData])

  const validationSchema = yup.object({
    car : yup
      .string('This Field is Required')
      .required('This Field is Required'),
    incident_date: yup
      .string('This Field is Required')
      .required('This Field is Required'),
    incidentType: yup
      .string('This Field is Required')
      .required('This Field is Required'),
    location: yup
      .string('This Field is Required')
      .required('This Field is Required'),
    severity: yup
      .string('This Field is Required')
      .required('This Field is Required'),
    damageDetail: yup
      .string('This Field is Required')
      .required('This Field is Required'),
    damageStatus: yup
      .string('This Field is Required')
      .required('This Field is Required'),
    // cost: yup                                 // ------------------- Condition
    //   .string('This Field is Required')
    //   .required('This Field is Required'),
    cost: yup.string().when([], {
      is: () => (formik.values?.damageStatus == "Closed"), // check your state here
      then: (schema) => schema.required("This Field is required"),
      otherwise: (schema) => schema.notRequired(),
    }),
    // claimStatus: yup
    //   .string('This Field is Required')
    //   .required('This Field is Required'),
    // policeReport: yup
    //   .string('This Field is Required')
    //   .required('This Field is Required'),
    employeeCost: yup.string().when([], {
      is: () => (formik.values?.damageStatus == "Closed"), // check your state here
      then: (schema) => schema.required("This Field is required"),
      otherwise: (schema) => schema.notRequired(),
    }),

    employerCost: yup.string().when([], {
      is: () => (formik.values?.damageStatus == "Closed"), // check your state here
      then: (schema) => schema.required("This Field is required"),
      otherwise: (schema) => schema.notRequired(),
    }),

    vendorCost: yup.string().when([], {
      is: () => (formik.values?.damageStatus == "Closed"), // check your state here
      then: (schema) => schema.required("This Field is required"),
      otherwise: (schema) => schema.notRequired(),
    }),

    insuranceCost: yup.string().when([], {
      is: () => (formik.values?.damageStatus == "Closed"), // check your state here
      then: (schema) => schema.required("This Field is required"),
      otherwise: (schema) => schema.notRequired(),
    }),
    // employeeCost: yup                         // ------------------- Condition
    //   .string('This Field is Required')
    //   .required('This Field is Required'),
    // employerCost: yup                         // ------------------- Condition
    //   .string('This Field is Required')
    //   .required('This Field is Required'),
    // vendorCost: yup                           // ------------------- Condition
    //   .string('This Field is Required')
    //   .required('This Field is Required'),
    // insuranceCost: yup                         // ------------------- Condition
    //   .string('This Field is Required')
    //   .required('This Field is Required'),
    incidentImg: yup
      .array()
      .min(1, "At least one image is required"),
    description: yup
      .string('This Field is Required')
      .required('This Field is Required'),
    comment: yup
      .string('This Field is Required')
      .required('This Field is Required')

  });

  const formik = useFormik({
    initialValues: {
      car:'',
      incident_date: '',
      incidentType: '',
      location: '',
      severity: '',
      damageDetail: '',
      damageStatus: '',
      cost: '',
      claimStatus: '',
      policeReport: '',
      employeeCost: '',
      employerCost: '',
      vendorCost: '',
      insuranceCost: '',
      description: '',
      comment: '',
      incidentImg: [],
      incidentImgLoader: false,
      invoiceLoader: false,
      invoice: ''
    },
    validationSchema: validationSchema,
    onSubmit: async (values) => {

      let extraData = {};

      if (damageData?.id) {
        extraData = {
          "id": damageData?.id
        }
      }

      let data = {
        ...extraData,
        "car_id": values?.car,
        "incident_date": values?.incident_date,
        "incident_type": values?.incidentType,  // 'Accident', 'Damage', 'Theft'
        "incident_location": values?.location,
        "description": values?.description,
        "severity": values?.severity,  // 'Minor', 'Moderate', 'Major'
        "damage_description": values?.damageDetail,
        "repair_cost": values?.cost,
        "insurance_claim_status": values?.claimStatus,  // 'Pending', 'Approved', 'Rejected'
        "police_report_number": values?.policeReport,
        "incident_images": values?.incidentImg,
        "invoice": values?.invoice,
        "repair_cost_breakup": {
          "employee": values?.employeeCost,
          "employer": values?.employerCost,
          "vendor": values?.vendorCost,
          "insurance": values?.insuranceCost
        },
        "final_comment": values?.comment,
        "damage_status": values?.damageStatus  // 'Open', 'Closed'
      }

      if(Math.round(Number(values?.employeeCost) + Number(values?.employerCost) + Number(values?.vendorCost) + Number(values?.insuranceCost)) != 100){
        console.log("Test Condtion")
        formik.setErrors({
          employeeCost: "Sum of all costs must equal 100",
          employerCost: "Sum of all costs must equal 100",
          vendorCost: "Sum of all costs must equal 100",
          insuranceCost: "Sum of all costs must equal 100",
        })
        return
      }

      try {
        let apiRes = await apiCall({ method: "post", url: "add-update-car-damage-record", data: data })
        formik.resetForm();
        onSubmit(apiRes?.message || `Request Submitted`);
      } catch (error) {
        console.log("Error", error)
        onError(error?.response.data?.respMsg || error?.response.data?.responseMessage || error?.response.data?.message || "Some Thing Went Wrong")
      }
    },
  });

  const handleFileUpload = async (file, type) => {
    let apiData = new FormData();
    apiData.append('file', file);
    if(type == "incidentImg"){
      setImgError([]);
      // formik.setFieldValue("contract", "");
      formik.setFieldValue("incidentImgLoader", true)
    }else{
      setInvoiceError(false);
      formik.setFieldValue("invoice", "");
      formik.setFieldValue("invoiceLoader", true)
    }
    try {
      let apiRes = await apiCall({ method: "post", url: "upload", data: apiData });
      if(type == "incidentImg"){
        formik.setFieldValue("incidentImg", [...formik.values?.incidentImg, apiRes?.path?.filepath]);
        formik.setFieldValue("incidentImgLoader", false);
      }else{
        formik.setFieldValue("invoice", apiRes?.path?.filepath);
        formik.setFieldValue("invoiceLoader", false)
      }
      console.log("apiRes", apiRes?.path?.filepath, type);
    } catch (error) {
      console.log("Error", error)
    }
  }

  return (
    <form onSubmit={formik.handleSubmit}>
      <LeftSidePopupLayout popupStatus={true} className={`${Style.addMeModal} ${Style.leaveModal} !gap-0`}>
        <div className={`${Style["modal_header"]} ${Style.addMeModal_head}`}>
          <h4>{(damageData?.id) ? "Update" : "Add"} Car Damage Record</h4>
          <div onClick={onClose} className={`${Style["close_btn"]} cursor-pointer`}><XCloseIcon /></div>
        </div>

        <div className={`${Style.addMeModal_body}`}>
          <div className={`${Style.dcmb__card}`}>
            <div className={`${Style.dcmb__cardBody}`}>
              <div className={`${Style.dcmb__cardBody_formArea} pt-3`}>

                <div className={Style["dcmb__cardBody_formArea_feild"]}>
                  <label htmlFor="">Car</label>
                  <select name='car' value={formik.values.car} onChange={formik.handleChange}>
                    <option value="" disabled selected>-- Select Car --</option>
                    {cars?.map((eachCar, index) => (
                      <option value={eachCar?.id} key={index}>{eachCar?.name}</option>
                    ))}
                  </select>
                  {
                    (formik.touched.car && Boolean(formik.errors.car)) ?
                      <span style={{ color: "red" }} className='ps-1'>{formik.touched.car && formik.errors.car}</span>
                      :
                      null
                  }
                </div>

                <div className={`${Style["dcmb__cardBody_formArea_feild"]}`}>
                  <div className={`${Style["dcmb__cardBody_formArea_feild"]}`}>
                    <label htmlFor="">Incident Date</label>
                    <input
                      type="date"
                      name='incident_date'
                      value={formik.values.incident_date}
                      onChange={formik.handleChange}
                    />
                    {
                      (formik.touched.incident_date && Boolean(formik.errors.incident_date)) ?
                        <span style={{ color: "red" }} className='ps-1'>{formik.touched.incident_date && formik.errors.incident_date}</span>
                        :
                        null
                    }
                  </div>
                </div>

                <div className={Style["dcmb__cardBody_formArea_feild"]}>
                  <label htmlFor="">Incident Type</label>
                  <select name='incidentType' value={formik.values.incidentType} onChange={formik.handleChange}>
                    <option value="" disabled selected>-- Select Type --</option>
                    <option value="Accident">Accident</option>
                    <option value="Damage">Damage</option>
                    <option value="Theft">Theft</option>
                  </select>
                  {
                    (formik.touched.incidentType && Boolean(formik.errors.incidentType)) ?
                      <span style={{ color: "red" }} className='ps-1'>{formik.touched.incidentType && formik.errors.incidentType}</span>
                      :
                      null
                  }
                </div>

                <div className={`${Style["dcmb__cardBody_formArea_feild"]}`}>
                  <div className={`${Style["dcmb__cardBody_formArea_feild"]}`}>
                    <label htmlFor="">Incident Location</label>
                    <input
                      type="text"
                      name='location'
                      value={formik.values.location}
                      onChange={formik.handleChange}
                      placeholder='Incident Location'
                    />
                    {
                      (formik.touched.location && Boolean(formik.errors.location)) ?
                        <span style={{ color: "red" }} className='ps-1'>{formik.touched.location && formik.errors.location}</span>
                        :
                        null
                    }
                  </div>
                </div>

                <div className={Style["dcmb__cardBody_formArea_feild"]}>
                  <label htmlFor="">Severity</label>
                  <select name='severity' value={formik.values.severity} onChange={formik.handleChange}>
                    <option value="" disabled selected>-- Select Severity --</option>
                    <option value="Minor">Minor</option>
                    <option value="Moderate">Moderate</option>
                    <option value="Major">Major</option>
                  </select>
                  {
                    (formik.touched.severity && Boolean(formik.errors.severity)) ?
                      <span style={{ color: "red" }} className='ps-1'>{formik.touched.severity && formik.errors.severity}</span>
                      :
                      null
                  }
                </div>

                <div className={`${Style["dcmb__cardBody_formArea_feild"]}`}>
                  <label htmlFor="">Damage Description</label>
                  <textarea name='damageDetail' value={formik.values.damageDetail} onChange={formik.handleChange} placeholder='Damage Description...'></textarea>
                  {
                    (formik.touched.damageDetail && Boolean(formik.errors.damageDetail)) ?
                      <span style={{ color: "red" }} className='ps-1'>{formik.touched.damageDetail && formik.errors.damageDetail}</span>
                      :
                      null
                  }
                </div>

                <div className={Style["dcmb__cardBody_formArea_feild"]}>
                  <label htmlFor="">Damage Status</label>
                  <select name='damageStatus' value={formik.values.damageStatus} onChange={formik.handleChange}>
                    <option value="" disabled selected>-- Select Damage Status --</option>
                    <option value="Open">Open</option>
                    <option value="Closed">Closed</option>
                  </select>
                  {
                    (formik.touched.damageStatus && Boolean(formik.errors.damageStatus)) ?
                      <span style={{ color: "red" }} className='ps-1'>{formik.touched.damageStatus && formik.errors.damageStatus}</span>
                      :
                      null
                  }
                </div>

                <div className={`${Style["dcmb__cardBody_formArea_feild"]}`}>
                  <label htmlFor="">Repair Cost</label>
                  <input
                    type="text"
                    name='cost'
                    value={formik.values.cost}
                    onChange={formik.handleChange}
                    placeholder='Repair Cost'
                  />
                  {
                    (formik.touched.cost && Boolean(formik.errors.cost)) ?
                      <span style={{ color: "red" }} className='ps-1'>{formik.touched.cost && formik.errors.cost}</span>
                      :
                      null
                  }
                </div>
                
                <div className={Style["dcmb__cardBody_formArea_feild"]}>
                  <label htmlFor="">Insurance Claim Status</label>
                  <select name='claimStatus' value={formik.values.claimStatus} onChange={formik.handleChange}>
                    <option value="" disabled selected>-- Select Insurance Status --</option>
                    <option value="Pending">Pending</option>
                    <option value="Approved">Approved</option>
                    <option value="Rejected">Rejected</option>
                  </select>
                  {
                    (formik.touched.claimStatus && Boolean(formik.errors.claimStatus)) ?
                      <span style={{ color: "red" }} className='ps-1'>{formik.touched.claimStatus && formik.errors.claimStatus}</span>
                      :
                      null
                  }
                </div>
                
                <div className={`${Style["dcmb__cardBody_formArea_feild"]}`}>
                  <label htmlFor="">Police Report Number</label>
                  <input
                    type="text"
                    name='policeReport'
                    value={formik.values.policeReport}
                    onChange={formik.handleChange}
                    placeholder='Police Report Number'
                  />
                  {
                    (formik.touched.policeReport && Boolean(formik.errors.policeReport)) ?
                      <span style={{ color: "red" }} className='ps-1'>{formik.touched.policeReport && formik.errors.policeReport}</span>
                      :
                      null
                  }
                </div>

                {formik?.values?.cost ?
                  <fieldset className='border-2 border-dashed border-gray-400 rounded-md p-4 pt-5'>
                    <legend className='text-gray-700 font-semibold text-[16px]'>Repair Cost Breakup</legend>
                    
                    <div className="flex gap-2 mb-3">
                      <div className={`${Style["dcmb__cardBody_formArea_feild"]} !gap-3`}>
                        <label htmlFor="">Employee</label>
                        <input
                          type="number"
                          name='employeeCost'
                          value={formik.values.employeeCost}
                          onChange={formik.handleChange}
                          placeholder='Employee Cost Percentage'
                        />
                        {
                          (formik.touched.employeeCost && Boolean(formik.errors.employeeCost)) ?
                            <span style={{ color: "red" }} className='ps-1'>{formik.touched.employeeCost && formik.errors.employeeCost}</span>
                            :
                            null
                        }
                      </div>
                      
                      <div className={`${Style["dcmb__cardBody_formArea_feild"]} !gap-3`}>
                        <label htmlFor="">Employer</label>
                        <input
                          type="number"
                          name='employerCost'
                          value={formik.values.employerCost}
                          onChange={formik.handleChange}
                          placeholder='Employer Cost Percentage'
                        />
                        {
                          (formik.touched.employerCost && Boolean(formik.errors.employerCost)) ?
                            <span style={{ color: "red" }} className='ps-1'>{formik.touched.employerCost && formik.errors.employerCost}</span>
                            :
                            null
                        }
                      </div>
                    </div>
                    
                    <div className="flex gap-2">
                      <div className={`${Style["dcmb__cardBody_formArea_feild"]} !gap-3`}>
                        <label htmlFor="">Vendor</label>
                        <input
                          type="number"
                          name='vendorCost'
                          value={formik.values.vendorCost}
                          onChange={formik.handleChange}
                          placeholder='Vendor Cost Percentage'
                        />
                        {
                          (formik.touched.vendorCost && Boolean(formik.errors.vendorCost)) ?
                            <span style={{ color: "red" }} className='ps-1'>{formik.touched.vendorCost && formik.errors.vendorCost}</span>
                            :
                            null
                        }
                      </div>
                      
                      <div className={`${Style["dcmb__cardBody_formArea_feild"]} !gap-3`}>
                        <label htmlFor="">Insurance</label>
                        <input
                          type="number"
                          name='insuranceCost'
                          value={formik.values.insuranceCost}
                          onChange={formik.handleChange}
                          placeholder='Insurance Cost Percentage'
                        />
                        {
                          (formik.touched.insuranceCost && Boolean(formik.errors.insuranceCost)) ?
                            <span style={{ color: "red" }} className='ps-1'>{formik.touched.insuranceCost && formik.errors.insuranceCost}</span>
                            :
                            null
                        }
                      </div>
                    </div>
                  </fieldset>
                  :
                  null
                }

                <div className={`${Style["dcmb__cardBody_formArea_feild"]}`}>
                  <label htmlFor="">Incident Images</label>
                  <label
                    onDrop={(e) => { e.preventDefault(); handleFileUpload(e.dataTransfer.files?.[0], "incidentImg") }}
                    onDragOver={(e) => e.preventDefault()}
                    className="flex flex-col !items-center justify-center w-full h-40 border-2 border-dashed border-gray-300 rounded-2xl cursor-pointer bg-gray-50 hover:bg-gray-100 transition"
                  >
                    {formik?.values?.incidentImgLoader ?
                      <InnerLoader wrapperClass="!w-10 !h-10" textStatus={false} />
                      :
                      <UploadCloud className="w-10 h-10 text-gray-500 mb-2" />
                    }
                    <p className="text-gray-600 font-medium">Drag & Drop files here</p>
                    <p className="text-sm text-gray-400">or click to browse</p>
                    <input
                      type="file"
                      onChange={(e) => { handleFileUpload(e.target.files[0], "incidentImg") }}
                      className="hidden"
                    />
                  </label>
                  {formik.values?.incidentImg?.length ?
                    <div className="flex items-center gap-1">
                      {formik.values?.incidentImg?.map((eachImg, i) => (
                        <Link key={i} to={eachImg} target='_blank' className='inline-block'>
                          {imgError[i] ?
                            <div className="h-20 w-20 shrink-0 rounded-md bg-gradient-to-br from-indigo-500/20 to-emerald-500/20 grid place-items-center text-xs font-medium">
                              <File />
                            </div>
                            :
                            <img src={eachImg} alt={"Incident Image"} className='h-20 w-20 rounded-md' onError={(e) => {
                              e.target.classList.add("hidden");
                              let errArr = [...imgError]
                              errArr[i] = true
                              setImgError(errArr);
                            }} />
                          }
                        </Link>
                      ))}
                    </div>
                    :
                    null
                  }
                  {
                    (formik.touched.incidentImg && Boolean(formik.errors.incidentImg)) ?
                      <span style={{ color: "red" }} className='ps-1'>{formik.touched.incidentImg && formik.errors.incidentImg}</span>
                      :
                      null
                  }
                </div>

                <div className={`${Style["dcmb__cardBody_formArea_feild"]}`}>
                  <label htmlFor="">Invoice</label>
                  <label
                    onDrop={(e) => { e.preventDefault(); handleFileUpload(e.dataTransfer.files?.[0], "invoice") }}
                    onDragOver={(e) => e.preventDefault()}
                    className="flex flex-col !items-center justify-center w-full h-40 border-2 border-dashed border-gray-300 rounded-2xl cursor-pointer bg-gray-50 hover:bg-gray-100 transition"
                  >
                    {formik?.values?.invoiceLoader ?
                      <InnerLoader wrapperClass="!w-10 !h-10" textStatus={false} />
                      :
                      <UploadCloud className="w-10 h-10 text-gray-500 mb-2" />
                    }
                    <p className="text-gray-600 font-medium">Drag & Drop files here</p>
                    <p className="text-sm text-gray-400">or click to browse</p>
                    <input
                      type="file"
                      onChange={(e) => { handleFileUpload(e.target.files[0], "invoice") }}
                      className="hidden"
                    />
                  </label>
                  {formik.values?.invoice ?
                    <div className="">
                      <Link to={formik.values?.invoice} target='_blank' className='inline-block'>
                        {invoiceError ?
                          <div className="h-20 w-20 shrink-0 rounded-md bg-gradient-to-br from-indigo-500/20 to-emerald-500/20 grid place-items-center text-xs font-medium">
                            <File />
                          </div>
                          :
                          <img src={formik.values?.invoice} alt={formik?.values?.companyName} className='h-20 w-20 rounded-md' onError={(e) => {
                            e.target.classList.add("hidden");
                            setInvoiceError(true);
                          }} />
                        }
                      </Link>
                    </div>
                    :
                    null
                  }
                  {
                    (formik.touched.invoice && Boolean(formik.errors.invoice)) ?
                      <span style={{ color: "red" }} className='ps-1'>{formik.touched.invoice && formik.errors.invoice}</span>
                      :
                      null
                  }
                </div>
                
                <div className={`${Style["dcmb__cardBody_formArea_feild"]}`}>
                  <label htmlFor="">Description</label>
                  <textarea name='description' value={formik.values.description} onChange={formik.handleChange} placeholder='Description...'></textarea>
                  {
                    (formik.touched.description && Boolean(formik.errors.description)) ?
                      <span style={{ color: "red" }} className='ps-1'>{formik.touched.description && formik.errors.description}</span>
                      :
                      null
                  }
                </div>
                
                <div className={`${Style["dcmb__cardBody_formArea_feild"]}`}>
                  <label htmlFor="">Comment</label>
                  <input
                    type="text"
                    name='comment'
                    value={formik.values.comment}
                    onChange={formik.handleChange}
                    placeholder='Final Comment'
                  />
                  {
                    (formik.touched.comment && Boolean(formik.errors.comment)) ?
                      <span style={{ color: "red" }} className='ps-1'>{formik.touched.comment && formik.errors.comment}</span>
                      :
                      null
                  }
                </div>

                {/* <div className={`${Style["dcmb__cardBody_formArea_feild"]}`}>
                  <div className={`${Style["dcmb__cardBody_formArea_feild"]}`}>
                    <label htmlFor="">Record Month</label>
                    <input
                      type="month"
                      name='record_month'
                      min={1}
                      value={formik.values.record_month}
                      onChange={formik.handleChange}
                      placeholder='Invoice month'
                    />
                    {
                      (formik.touched.record_month && Boolean(formik.errors.record_month)) ?
                        <span style={{ color: "red" }} className='ps-1'>{formik.touched.record_month && formik.errors.record_month}</span>
                        :
                        null
                    }
                  </div>
                </div>

                <div className={`${Style["dcmb__cardBody_formArea_feild"]}`}>
                  <div className={`${Style["dcmb__cardBody_formArea_feild"]}`}>
                    <label htmlFor="">Km</label>
                    <input
                      type="text"
                      name='km'
                      value={formik.values.km}
                      onChange={formik.handleChange}
                      placeholder='Km'
                    />
                    {
                      (formik.touched.km && Boolean(formik.errors.km)) ?
                        <span style={{ color: "red" }} className='ps-1'>{formik.touched.km && formik.errors.km}</span>
                        :
                        null
                    }
                  </div>
                </div>

                <div className={`${Style["dcmb__cardBody_formArea_feild"]}`}>
                  <div className={`${Style["dcmb__cardBody_formArea_feild"]}`}>
                    <label htmlFor="">Record Date</label>
                    <input
                      type="date"
                      name='record_date'
                      value={formik.values.record_date}
                      onChange={formik.handleChange}
                      placeholder='Invoice Date'
                    />
                    {
                      (formik.touched.record_date && Boolean(formik.errors.record_date)) ?
                        <span style={{ color: "red" }} className='ps-1'>{formik.touched.record_date && formik.errors.record_date}</span>
                        :
                        null
                    }
                  </div>
                </div> */}
              
              </div>
            </div>
          </div>
        </div>

        <div className={`${Style.dcmb__cardFoot}`}>
          <button type='reset' className={`${Style.dcmb__cancel}`} onClick={onClose}>Discard</button>
          <button type='submit' className={`${Style.dcmb__submit}`}>Apply</button>
        </div>
      </LeftSidePopupLayout>
    </form>
  )
}

export default CarDamageModal